import React from 'react';
import ModalComponent from 'components/Common/Modal';
import { useAuth0 } from '@auth0/auth0-react';
import { Link } from 'react-router';

const RateLimitManifestos = (props) => {
  const { openState } = props;
  const { isOpen, setIsOpen } = openState ?? {};
  const { isAuthenticated } = useAuth0();

  return (
    <ModalComponent
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      maxWidth={900}
      overlayClassName='react-modal-overlay report-extra-index-modal'
    >
      <div className='bg-grey rounded-lg relative'>
        <div className='d-lg-flex'>
          <div className='bg-main-blue py-5 text-left d-none d-lg-block rounded-left-lg'>
            <h3 className='title-h3 pl-lg-5 report-prospecting-title'>
              <img
                src={`${import.meta.env.VITE_APP_CDNURL}/images/logo_white.svg`}
                alt='Logo'
                className='policy-logo mr-2'
              />
            </h3>

            <ul className='policy-list text-white text-left title-h5-m py-4 mt-4 manifesto-popup-list statistics-popup-list px-3 pl-lg-5 pr-lg-0'>
              <li className='pl-4 mb-3 py-2 nowrap-item bg-grey text-main-blue statistics-list-active-item '>
                <span className='inline-block title-h3 mr-3 icon-small-check' />
                15 manifesto searches / day
              </li>
              <li className='pl-4 mb-3 py-2 nowrap-item '>
                <span className='inline-block title-h3 mr-3 icon-small-check' />
                Powerful political monitoring
              </li>
              <li className='pl-4 mb-3 py-2 nowrap-item '>
                <span className='inline-block title-h3 mr-3 icon-small-check' />
                Advanced stakeholder mapping
              </li>
              <li className='pl-4 mb-3 py-2 nowrap-item '>
                <span className='inline-block title-h3 mr-3 icon-small-check' />
                Fully integrated CRM
              </li>
            </ul>
          </div>
          <div className='grow px-5 pb-5 mb-3'>
            <p className='title-h2 mt-3 pt-3 pt-lg-5 mb-4 flex-centered'>
              <span className='font-weight-bold d-inline-block pr-lg-3'>
                {'You have reached the limit of 3 searches in the past 24 hours'}
              </span>
            </p>

            <div className='title-h3 main-light-text pr-lg-4'>
              <p>
                To continue using the manifesto tracking tool today, please subscribe to{' '}
                <span className='main-subtle-text font-weight-bold'>any of our paid subscription plans</span>
              </p>
            </div>

            <div className='nowrap-item text-lg-right pt-5 mt-lg-5 d-lg-flex align-items-center justify-content-end'>
              <Link
                className='downgrade-pricing-button mt-3 mt-lg-0 action-button rounded-button py-2 px-3 px-xxl-5 d-inline-block title-h5-m text-center'
                to={`/${isAuthenticated ? 'pricing' : 'register?reg_source=election-hub-manifesto-compare'}`}
              >
                <span className='px-4'>
                  {isAuthenticated ? 'Compare plans' : 'Try PolicyMogul for free'}
                  <span className='icon-long-arrow-right paragraph-p5 inline-block ml-2 ml-lg-3' />
                </span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </ModalComponent>
  );
};

export default RateLimitManifestos;
